export const ORDER_PAGE_MODE = {
    livestream: 'livestream',
    affiliate: 'affiliate',
} as const;

export type OrderPageMode = (typeof ORDER_PAGE_MODE)[keyof typeof ORDER_PAGE_MODE];

export const ORDER_PAGE_TEXT: Record<
    OrderPageMode,
    {
        codButton: string;
        successMessage: string;
        failedMessage: string;
        policyVerb: string;
        missingLinkMessage: string;
        unavailableMessage: string;
    }
> = {
    livestream: {
        codButton: 'Chốt đơn',
        successMessage: 'Chốt đơn thành công',
        failedMessage: 'Chốt đơn thất bại',
        policyVerb: 'Chốt đơn',
        missingLinkMessage: 'Vui lòng dùng link sản phẩm từ phiên livestream',
        unavailableMessage: 'Sản phẩm không được bán trong phiên livestream',
    },
    affiliate: {
        codButton: 'Đặt hàng',
        successMessage: 'Đặt hàng thành công',
        failedMessage: 'Đặt hàng thất bại',
        policyVerb: 'Đặt hàng',
        missingLinkMessage: 'Vui lòng dùng link sản phẩm hợp lệ',
        unavailableMessage: 'Sản phẩm không tồn tại hoặc chưa được mở bán',
    },
};
